<template>
    <div class="DshAvatar">
        <!-- 无显示 -->
        <template v-if="users.length == 0">

        </template>

        <!-- 图片堆叠显示 -->
        <div v-else-if="users.length > maxLength" :style="{...roundStyle}">
            <span v-for="(user, index) in userList" :key="index" class="DshAvatar-img">
                <img :src="user && user.avatarurl || avatarSrc">
            </span>
            <span :style="{'margin-left': (userList.length + 1) * 12 + 6 + 'px'}">
                {{userList[userList.length - 1] && userList[userList.length - 1].realname || userList[userList.length - 1].name || "吴明昊"}}
            </span>
        </div>

        <!-- 单个显示 -->
        <template v-else>
            <div v-for="(user, index) in users" :key="index" class="DshAvatar-round" :style="{...roundStyle}">
                <div class="DshAvatar-box">
                    <div class="DshAvatar-img">
                        <img :src="user && user.avatarurl || avatarSrc">
                    </div>
                    <span>
                        {{user && user.realname || user && user.name || ""}}
                    </span>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    // 自定义列组件
    export default {
        name: "DshAvatar",
        props: {
            rowData: {
                type: Object
            },
            field: {
                type: String
            },
            // 最多显示maxlength个，超出后头像重叠显示最后一个人的名字
            maxLength: {
                type: Number,
                default: 2
            },
            roundStyle: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        data () {
            return {
                avatarSrc: this.$imageSrcMap.system.boy,

                users: []
            };
        },
        computed: {
            userList () {
                return this.users.slice(0, 4);
            }
        },
        created () {
            this.init();
        },
        methods: {
            init () {
                this.users = this.$dataType(this.rowData[this.field]) === "object" ? [this.rowData[this.field]] : (this.$dataType(this.rowData[this.field]) === "array" ? this.rowData[this.field] : []);
            }
        },
        watch: {
            rowData: {
                handler (newVal, oldVal) {
                    this.init();
                },
                immediate: true
            }
        }
    };
</script>

<style lang="less">
    .DshAvatar {
        position: relative;
        span {
            display: inline-block;
            margin-left: 20px;
            line-height: 22px;
        }
        &-img {
            width: 22px;
            height: 22px;
            padding: 1px;
            display: inline-block;
            line-height: 20px;
            background: #fff;
            border-radius: 50%;
            img {
                width: 20px;
                height: 20px;
                display: inline-block;
                border-radius: 50%;
            }
            &:nth-child(1) {
                position: absolute;
                left: 0px;
                top: 50%;
                margin-top: -10px;
            }
            &:nth-child(2) {
                position: absolute;
                left: 12px;
                top: 50%;
                margin-top: -10px;
            }
            &:nth-child(3) {
                position: absolute;
                left: 24px;
                top: 50%;
                margin-top: -10px;
            }
            &:nth-child(4) {
                position: absolute;
                left: 36px;
                top: 50%;
                margin-top: -10px;
            }
        }
        &-round {
            display: inline-block;
            margin-right: 8px;
        }
        &-box {
            position: relative;
            img {
                width: 20px;
                height: 20px;
                display: inline-block;
                border-radius: 50%;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/other/DshAvatar.vue